import { Component, createRef } from "react";
import styles from "./jetpass-selection.module.less";
import JetpassContext from "components/stores/jetpass-context";
import JetpassIntro from "components/block-elements/jetpass-intro/jetpass-intro";
import JetpassSlotSelection from "components/block-elements/jetpass-slot-selection/jetpass-slot-selection";
import JetPassNameSelection from "components/block-elements/jetpass-name-selection/jetpass-name-selection";
import { INTRO_STEP, MANDATORY_PASSES_STEP, JETPASS_STEP, NAMING_STEP } from "./constants/jetpass-constants";
import {
  extract,
  DateHelper,
  isArray,
  SessionStorageHelper,
  createDate,
  RideStore,
  EventAggregator,
  GhostButton,
  TimeSlotService,
} from "@parksandresorts/core";
import { sortByNumberOfJetpasses } from "components/helpers";

export default class JetpassSelection extends Component {
  constructor(props) {
    super(props);
    this.jetPassDate = extract(this.props, "jetPassDate");
    this.theme = extract(this.props, "theme");
    this.disableOpenCart = extract(this.props, "disableOpenCart");

    this.remainingPreSelectedTimePassIds = this.getPreSelectedEntryPassIds();
    this.remainingPreSelectedJetPassIds = this.getPreSelectedJetPassIds();

    this.filterOutTimesBefore = extract(this.props, "jetPassOptions.filterOutTimesBefore", null);

    this.navigateTo = this.navigateTo.bind(this);
    this.optOut = this.optOut.bind(this);
    this.removeTimeSlot = this.removeTimeSlot.bind(this);
    this.selectTimeSlot = this.selectTimeSlot.bind(this);
    this.jetPassIntroSeen = SessionStorageHelper.getItem("jetPassIntroSeen");
    this.numberOfGuests = extract(this.props, "guests.length", 1);

    this.selectActiveGuest = this.selectActiveGuest.bind(this);
    this.toggleSelectForAll = this.toggleSelectForAll.bind(this);
    this.nextStep = this.nextStep.bind(this);
    this.setNamesForGuests = this.setNamesForGuests.bind(this);

    this.scrollRef = createRef();

    this.state = {
      currentStep: this.getInitialStep(),
      dataLoaded: false,
      selectForAll: true,
      activeGuestIndex: 0,
      namesSubmitted: isArray(this.props.preCreatedGuests) ? true : false,
      lockSelectForAllToggle: false,
      lastActiveStep: null,
    };
  }

  componentDidMount() {
    const date = DateHelper.toStringYYYYMMDD(this.jetPassDate);

    // const preSelectedTimePassWithTimeStamps = this.convertPreSelectedToTimeStamps(this.preSelectedTimePass);
    // const preSelectedJetPassWithTimeStamps = this.convertPreSelectedToTimeStamps(this.preSelectedJetPass);
    // const preCreatedGuests = extract(this.props, 'preCreatedGuests', []);
    const guests = extract(this.props, "guests", []);
    guests.sort(sortByNumberOfJetpasses);

    this.context.createInitialGuests(guests);

    const glkId = extract(guests[0], "product.glkId", null);

    if (!glkId) {
      EventAggregator.publish("trackException", {
        exception: new Error("No GLKID found for first guest"),
      });
    }

    TimeSlotService.getEntrancesAndJetpassTimeslots(glkId, date)
      .then(async (data) => {
        const timePassTimeSlots = this.extendTimeslotData(data.response.timePassTimeSlots, true, 0);
        const jetPassTimeSlots = this.extendTimeslotData(data.response.jetPassTimeSlots, false, 0);

        this.extendedTimePassTimeslots = timePassTimeSlots ? timePassTimeSlots : [];
        this.extendedJetPassTimeslots = jetPassTimeSlots ? jetPassTimeSlots : [];
        this.setState({ dataLoaded: true });
      })
      .catch((error) => {
        EventAggregator.publish("trackException", {
          exception: error,
          customMessage: "JetpassSelection getJetpassTimeslotsGLK",
        });
        this.setState({ dataLoaded: true });
      });
  }

  getPreSelectedEntryPassIds() {
    if (!isArray(this.props.guests)) {
      return [];
    }

    const preSelectedIds = [];

    for (const guest of this.props.guests) {
      if (isArray(guest.entryPasses)) {
        const ids = guest.entryPasses.map((pass) => pass.attractionId);

        preSelectedIds.push(...ids);
      }
    }

    return preSelectedIds;
  }

  getPreSelectedJetPassIds() {
    if (!isArray(this.props.guests)) {
      return [];
    }

    const preSelectedIds = [];

    for (const guest of this.props.guests) {
      if (isArray(guest.jetPasses)) {
        const ids = guest.jetPasses.map((pass) => pass.attractionId);

        preSelectedIds.push(...ids);
      }
    }

    return preSelectedIds;
  }

  getInitialStep() {
    const disableJetPassIntro = extract(this.props, "jetPassOptions.disableIntro", null) || this.props.disableIntroStep;

    if (this.jetPassIntroSeen || disableJetPassIntro) {
      const firstGuestNumberOfEntryTickets = extract(this.props, "guests[0].numberOfEntryTickets", 0);
      return firstGuestNumberOfEntryTickets > 0 ? MANDATORY_PASSES_STEP : JETPASS_STEP;
    }

    return INTRO_STEP;
  }

  addProductToCart() {
    if (!this.props.cartContext) {
      return;
    }

    const addToCartItems = [];

    if (isArray(this.context.guests)) {
      for (const guest of this.context.guests) {
        const allPasses = [...guest.entryPasses, ...guest.jetPasses];
        const cartItem = {
          ...guest.productInfo,
          quantity: 1,
          expressPass: isArray(allPasses) ? { customerName: guest.name, timeSlots: allPasses } : null,
        };

        addToCartItems.push(cartItem);
      }
    }

    this.props.cartContext
      .addCart(addToCartItems)
      .then((response) => {
        if (this.props.onDoneAddToCart && typeof this.props.onDoneAddToCart === "function") {
          this.props.onDoneAddToCart();
        }

        if (this.disableOpenCart === false) {
          this.props.globalContext.setValue({
            showCart: true,
            showMenu: false,
            showSearch: false,
            isMenuAnimating: true,
            isMenuAnimationDone: false,
          });
        }

        this.context.setValue({
          ...this.context,
          guests: [
            {
              name: "Gäst 1",
              selectedPasses: [],
              totalPasses: 0,
              selectionComplete: true,
            },
          ],
          allSelectionComplete: false,
        });
        /*
                          if(this.props.globalContext.showPageInOverlay) {
                              this.props.globalContext.setValue({ animateClosePageInOverlay: true })
                          }*/
      })
      .catch((err) => {
        EventAggregator.publish("trackException", {
          exception: err,
          customMessage: "JetpassSelection addProductToCart",
        });
      });
  }

  closeJetPassSelection() {
    this.props.cartContext.setValue({
      showJetPassModal: false,
      jetPassAlternativeOptOut: null,
      guests: null,
      jetPassOptions: {},
    });
    this.context.resetToDefault();
  }

  toggleSelectForAll() {
    if (this.state.selectForAll) {
      if (!this.state.namesSubmitted) {
        this.setState({ selectForAll: false, currentStep: NAMING_STEP, lastActiveStep: this.state.currentStep });
      }

      this.setState({ selectForAll: false });
    } else {
      this.context.clearCurrentSelectionForGuests();
      this.setState({ selectForAll: true, currentStep: this.getInitialStep() });
    }
  }

  optOut() {
    this.context.setValue({ selectionComplete: true });
    this.props.cartContext.setValue({ showJetPassModal: false, jetPassAlternativeOptOut: null, jetPassOptions: {} });

    if (this.props.alternativeOptOut && typeof this.props.alternativeOptOut === "function") {
      const selectionData = { guests: this.context.guests, date: this.jetPassDate };
      this.props.alternativeOptOut(selectionData, this.state.selectForAll);
    } else {
      this.addProductToCart(this.jetPassProduct, false);
    }
  }

  navigateTo(page) {
    this.setState({ currentStep: page });
  }

  nextStep() {
    if (this.state.currentStep === INTRO_STEP) {
      const firstGuestNumberOfEntryTickets = extract(this.props, "guests[0].numberOfEntryTickets", 0);
      this.setState({ currentStep: firstGuestNumberOfEntryTickets > 0 ? MANDATORY_PASSES_STEP : JETPASS_STEP });
      return;
    }

    this.setState({
      currentStep: JETPASS_STEP,
      activeGuestIndex: 0,
      lockSelectForAllToggle: this.state.selectForAll ? false : true,
    });
  }

  extendedTimeSlotsWithPreSelected(attractionId, timeslots, isTimePassExtension) {
    if (!isArray(timeslots)) {
      return [];
    }

    const remainingPreSelectedIds = isTimePassExtension
      ? this.remainingPreSelectedTimePassIds
      : this.remainingPreSelectedJetPassIds;
    const preSelectedPasses = isTimePassExtension
      ? extract(this.props, "guests[0].entryPasses", [])
      : extract(this.props, "guests[0].jetPasses", []);

    if (!remainingPreSelectedIds.includes(attractionId)) {
      return timeslots;
    }

    const timeBooking = preSelectedPasses.find((pass) => pass.attractionId === attractionId);

    const timeSlotsWithAdjustedQuantity = timeslots.map((timeslot) => {
      if (timeslot.timeSlotFrom === timeBooking.timeSlotFrom) {
        return {
          ...timeslot,
          quantity: timeslot.quantity + 1,
        };
      }

      return timeslot;
    });

    if (isTimePassExtension) {
      this.remainingPreSelectedTimePassIds = this.remainingPreSelectedTimePassIds.filter((id) => id !== attractionId);
    } else {
      this.remainingPreSelectedJetPassIds = this.remainingPreSelectedJetPassIds.filter((id) => id !== attractionId);
    }

    return timeSlotsWithAdjustedQuantity;
  }

  extendTimeslotData(jetPassSlots, isTimePassExtension, minQuantity = 1) {
    if (!jetPassSlots) {
      return null;
    }

    const extendedJetPassData = [];

    for (const ride of jetPassSlots) {
      const extendedRideData = RideStore.getRideById(ride.attractionId);
      const rideImage = extract(extendedRideData, "imageInList.file.url");
      const minHeight = extract(extendedRideData, "minimumHeight", null);
      const ageRequirement = extract(extendedRideData, "ageRequirement", null);
      const jetpassSelectSlotText = extract(extendedRideData, "jetpassSelectSlotText", null);
      const contentfulAttractionName = extract(extendedRideData, "title", null);
      const timeSlotsExtendedWithPreselected = this.extendedTimeSlotsWithPreSelected(
        ride.attractionId,
        ride.timeSlots,
        isTimePassExtension,
      );
      const timeSlotWithMinQuantity = timeSlotsExtendedWithPreselected.filter((slot) => slot.quantity >= minQuantity);
      const timeSlotsWithTimeFilters = this.filterOutTimesBefore
        ? timeSlotWithMinQuantity.filter((timeslot) => {
            return createDate(timeslot.timeSlotFrom) >= createDate(this.filterOutTimesBefore);
          })
        : timeSlotWithMinQuantity;
      const timeSlots = this.extendTimeSlotsWithTimeZone(timeSlotsWithTimeFilters);

      const extendedTimeslot = {
        ...ride,
        timeSlots: timeSlots,
        image: rideImage,
        minHeight: minHeight,
        ageRequirement: ageRequirement,
        contentfulAttractionName: contentfulAttractionName,
        jetpassSelectSlotText: jetpassSelectSlotText,
      };

      extendedJetPassData.push(extendedTimeslot);
    }

    if (isTimePassExtension) {
      if (!isArray(this.remainingPreSelectedTimePassIds)) {
        return extendedJetPassData;
      }
    } else {
      if (!isArray(this.remainingPreSelectedJetPassIds)) {
        return extendedJetPassData;
      }
    }

    for (const attractionId of this.remainingPreSelectedJetPassIds) {
      const extendedRideData = RideStore.getRideById(attractionId);

      const preSelectedJetPass = extract(this.props, "guests[0].jetPasses", []);

      const preSelectedTimeslot = preSelectedJetPass.find((pass) => pass.attractionId === attractionId);

      if (preSelectedTimeslot) {
        const newVirtualAttraction = this.createNewVirtualAttractionFromTimeslot(
          extendedRideData,
          preSelectedTimeslot,
          attractionId,
        );
        extendedJetPassData.push(newVirtualAttraction);
      }
    }

    for (const attractionId of this.remainingPreSelectedTimePassIds) {
      const extendedRideData = RideStore.getRideById(attractionId);

      const preSelectedTimePass = extract(this.props, "guests[0].entryPasses", []);

      const preSelectedTimeslot = preSelectedTimePass.find((pass) => pass.attractionId === attractionId);

      if (preSelectedTimeslot) {
        const newVirtualAttraction = this.createNewVirtualAttractionFromTimeslot(
          extendedRideData,
          preSelectedTimeslot,
          attractionId,
        );
        extendedJetPassData.push(newVirtualAttraction);
      }
    }

    return extendedJetPassData;
  }

  createNewVirtualAttractionFromTimeslot(extendedRideData, preSelectedTimeslot, attractionId) {
    const contentfulAttractionName = extract(extendedRideData, "title", "Namn saknas.");
    const rideImage = extract(extendedRideData, "imageInList.file.url", null);

    const virtualAttraction = {
      attractionId: attractionId,
      contentfulAttractionName: contentfulAttractionName,
      image: rideImage,
      timeSlots: [
        {
          quantity: 1,
          timeSlotBegin: preSelectedTimeslot.timeSlotFrom,
          timeSlotEnd: preSelectedTimeslot.timeSlotTo,
        },
      ],
    };

    return virtualAttraction;
  }

  convertPreSelectedToTimeStamps(preSelected) {
    const extendedPreselected = [];
    if (!isArray(preSelected)) {
      return extendedPreselected;
    }

    for (const slot of preSelected) {
      extendedPreselected.push({
        ...slot,
        startDateTime: slot.timeSlotFrom,
        endDateTime: slot.timeSlotTo,
      });
    }

    return extendedPreselected;
  }

  extendTimeSlotsWithTimeZone(timeSlots) {
    const extendedTimeSlots = [];
    if (!isArray(timeSlots)) {
      return extendedTimeSlots;
    }

    for (const timeSlot of timeSlots) {
      extendedTimeSlots.push({
        ...timeSlot,
        timeSlotBegin: timeSlot.timeSlotFrom,
        timeSlotEnd: timeSlot.timeSlotTo,
      });
    }

    return extendedTimeSlots;
  }

  isTimeSlotAfterSelectedEntryTime(timeSlot, activeGuest) {
    const entryTime = extract(activeGuest, "entryPasses[0].startDateTime", null);
    if (!entryTime) {
      return true;
    }

    const entryTimeAsDate = createDate(entryTime);
    const timeslotAsDate = createDate(timeSlot);
    return timeslotAsDate >= entryTimeAsDate;
  }

  extendDataWithSelectedTimeslot(selectionData) {
    if (!selectionData) {
      return null;
    }

    const activeGuest = this.state.selectForAll
      ? this.context.getGuestWithMostJetpass()
      : this.context.guests[this.state.activeGuestIndex];
    const activeGuestPasses =
      activeGuest[this.state.currentStep === MANDATORY_PASSES_STEP ? "entryPasses" : "jetPasses"];

    const extendedData = selectionData.map((attraction) => {
      const selectedTimeslotObject = activeGuestPasses.find((pass) => pass.attractionId === attraction.attractionId);

      return {
        ...attraction,
        selectedTimeSlot: selectedTimeslotObject ? selectedTimeslotObject.startDateTime : null,
        timeSlots:
          this.state.currentStep === JETPASS_STEP
            ? attraction.timeSlots.filter((timeslot) =>
                this.isTimeSlotAfterSelectedEntryTime(timeslot.timeSlotBegin, activeGuest),
              )
            : attraction.timeSlots,
      };
    });

    return extendedData;
  }

  selectActiveGuest(guestNumber) {
    if (guestNumber >= 0 && guestNumber < extract(this.props, "guests.length", 1)) {
      this.setState({ activeGuestIndex: guestNumber });
    }
  }

  removeTimeSlot(attractionId) {
    const options = {
      selectForAll: this.state.selectForAll,
      entryPasses: this.state.currentStep === MANDATORY_PASSES_STEP ? true : false,
    };
    this.context.removeTimeSlot(attractionId, this.state.activeGuestIndex, options);
  }

  selectTimeSlot(timeSlot, attractionId) {
    const options = {
      selectForAll: this.state.selectForAll,
      entryPasses: this.state.currentStep === MANDATORY_PASSES_STEP ? true : false,
    };
    this.context.selectTimeSlot(timeSlot, attractionId, this.state.activeGuestIndex, options);
  }

  getNumberOfTotalSelectedPassesForAllGuests() {
    let numberOfTotalSelectedJetpass = 0;
    if (!isArray(this.context.guests)) {
      return null;
    }

    for (const guest of this.context.guests) {
      numberOfTotalSelectedJetpass = numberOfTotalSelectedJetpass + guest.jetPasses.length;
    }

    return numberOfTotalSelectedJetpass;
  }

  getNumberOfTotalPassesForAllGuests() {
    let numberOfTotalJetpasses = 0;
    if (!isArray(this.context.guests)) {
      return null;
    }

    for (const guest of this.context.guests) {
      numberOfTotalJetpasses = numberOfTotalJetpasses + guest.numberOfJetpasses;
    }

    return numberOfTotalJetpasses;
  }

  getActiveGuest() {
    if (this.state.selectForAll) {
      //might need implementation of function that finds the guest with the most jetpasses
      return this.context.getGuestWithMostJetpass();
    }

    return this.context.guests[this.state.activeGuestIndex];
  }

  getAllGuestsJetpasses() {
    const allGuestsJetpasses = this.context.guests.filter((guest) => guest.numberOfJetpasses !== 0);
    if (allGuestsJetpasses && allGuestsJetpasses.length > 0) {
      return false;
    }
    return true;
  }

  getBackFunction() {
    if (this.props.numberOfEntryTicketsIncluded && this.props.numberOfEntryTicketsIncluded > 0) {
      return () => this.setState({ currentStep: MANDATORY_PASSES_STEP });
    }

    return null;
  }

  setNamesForGuests(names) {
    this.context.setNamesForGuests(names);
    this.setState({ currentStep: this.state.lastActiveStep, namesSubmitted: true });
  }

  getComponentForStep() {
    const selectionDataWithSelectedTimeslots = this.extendDataWithSelectedTimeslot(
      this.state.currentStep === MANDATORY_PASSES_STEP ? this.extendedTimePassTimeslots : this.extendedJetPassTimeslots,
    );

    const activeGuest = this.getActiveGuest();
    const isLastStepForAllGuests = this.getAllGuestsJetpasses();

    switch (this.state.currentStep) {
      case NAMING_STEP: {
        return (
          <JetPassNameSelection
            guests={this.context.guests}
            numberOfGuests={this.numberOfGuests}
            onSubmitNames={this.setNamesForGuests}
            onCancelSubmitNames={() => this.setState({ currentStep: this.state.lastActiveStep })}
          />
        );
      }
      case MANDATORY_PASSES_STEP: {
        return (
          <JetpassSlotSelection
            scrollRef={this.scrollRef}
            key={MANDATORY_PASSES_STEP}
            productQuantity={extract(this.props, "guests.length", 1)}
            optOut={this.optOut}
            nextStep={this.nextStep}
            stepType={MANDATORY_PASSES_STEP}
            selectionComplete={activeGuest.entryPassSelectionComplete}
            allSelectionComplete={this.context.allEntryTicketsSelectionComplete}
            numberOfTotalPasses={activeGuest.numberOfEntryTickets}
            numberOfTotalSelectedPasses={extract(activeGuest, "entryPasses.length", 0)}
            removeTimeSlot={this.removeTimeSlot}
            selectTimeSlot={this.selectTimeSlot}
            selectActiveGuest={this.selectActiveGuest}
            multiSelection={!this.state.selectForAll}
            toggleMultiSelection={this.toggleSelectForAll}
            numberOfGuests={this.numberOfGuests}
            guests={this.context.guests}
            activeGuest={activeGuest}
            isLastStep={isLastStepForAllGuests}
            multiSelectionGuestIndex={this.state.activeGuestIndex}
            selectionData={selectionDataWithSelectedTimeslots}
            customHeading={extract(this.props, "jetPassOptions.customHeadingEntrypass", null)}
            productTimeLimit={extract(activeGuest, "productTimeLimit", null)}
          />
        );
      }

      case JETPASS_STEP: {
        return (
          <JetpassSlotSelection
            scrollRef={this.scrollRef}
            key={JETPASS_STEP}
            onBack={this.getBackFunction()}
            productQuantity={extract(this.props, "guests.length", 1)}
            optOut={this.optOut}
            stepType={JETPASS_STEP}
            selectedEntryTime={extract(activeGuest, "entryPasses[0]", null)}
            lockMultiSelectionToggle={this.state.lockSelectForAllToggle}
            selectionComplete={activeGuest.jetpassSelectionComplete}
            allSelectionComplete={this.context.allSelectionComplete}
            numberOfTotalPasses={
              this.state.selectForAll ? activeGuest.numberOfJetpasses : this.getNumberOfTotalPassesForAllGuests()
            }
            numberOfTotalSelectedPasses={
              this.state.selectForAll
                ? extract(activeGuest, "jetPasses.length", 0)
                : this.getNumberOfTotalSelectedPassesForAllGuests()
            }
            removeTimeSlot={this.removeTimeSlot}
            selectTimeSlot={this.selectTimeSlot}
            selectActiveGuest={this.selectActiveGuest}
            multiSelection={!this.state.selectForAll}
            toggleMultiSelection={this.toggleSelectForAll}
            numberOfGuests={this.numberOfGuests}
            guests={this.context.guests}
            activeGuest={activeGuest}
            multiSelectionGuestIndex={this.state.activeGuestIndex}
            selectionData={selectionDataWithSelectedTimeslots}
            productTimeLimit={extract(activeGuest, "productTimeLimit", null)}
            alreadySelectedPasses={extract(this.props, "jetPassOptions.alreadySelectedJetpasses", [])}
            customHeading={extract(this.props, "jetPassOptions.customHeadingJetpass", null)}
            enableBackButton={extract(this.props, "jetPassOptions.enableBackButton", true)}
          />
        );
      }

      case INTRO_STEP:
      default: {
        return (
          <JetpassIntro
            optOut={() => this.optOut()}
            navigateNext={this.nextStep}
            numberOfTotalPasses={this.context.totalPasses}
            displaySkipButton={
              this.props.numberOfEntryTicketsIncluded && this.props.numberOfEntryTicketsIncluded > 0 ? false : true
            }
          />
        );
      }
    }
  }

  render() {
    return (
      <div ref={this.scrollRef} className={`${styles.wrapper} theme-${this.theme}`}>
        <div className={styles.buttonWrapper}>
          <GhostButton
            className={styles.closeButton}
            onClick={() => {
              this.closeJetPassSelection();
            }}
            iconCenterNew="close"
            size="small"
          />
        </div>
        {this.getComponentForStep()}
      </div>
    );
  }
}

JetpassSelection.contextType = JetpassContext;

JetpassSelection.defaultProps = {
  numberOfEntryTicketsIncluded: 1,
};
